import { StyledCheckboxArea } from './style'
import { DropDownListOptionType } from 'types/common/CommonType'
import { Checkbox } from 'components/button/Checkbox/Checkbox'

interface CheckboxAreaType {
  label: string
  required: boolean
  disabled?: boolean
  options: DropDownListOptionType[]
  direction?: 'horizontal' | 'vertical'
  maxHeight?: string
  selectedOptions: DropDownListOptionType[]
  setSelectedOptions: React.Dispatch<React.SetStateAction<DropDownListOptionType[]>>
}

export const CheckboxArea = ({
  label,
  required = false,
  disabled = false,
  options,
  direction = 'horizontal',
  maxHeight = '8rem',
  selectedOptions,
  setSelectedOptions,
}: CheckboxAreaType) => {
  const handleCheckboxChange = (
    checked: boolean,
    selectedLabel: string,
    selectedRoleId: string
  ) => {
    if (checked) {
      setSelectedOptions([...selectedOptions, { label: selectedLabel, value: selectedRoleId }])
    } else {
      setSelectedOptions([
        ...selectedOptions.filter((item) => {
          return item.value !== selectedRoleId
        }),
      ])
    }
  }

  return (
    <StyledCheckboxArea className={`checkbox-area`} $direction={direction} $maxHeight={maxHeight}>
      <p className="checkbox-area-label">
        {label}
        {required && <span className="required">*</span>}
      </p>
      <div className="checkbox-area-content">
        {options.map((option, index) => (
          <Checkbox
            disabled={disabled || option?.disabled === true}
            key={index}
            label={option.label}
            id={option.label}
            checked={selectedOptions?.some((selectedOption) => {
              return selectedOption.label === option.label
            })}
            handleChecked={(checked) =>
              handleCheckboxChange(checked, option.label, option.value as string)
            }
          />
        ))}
      </div>
    </StyledCheckboxArea>
  )
}
